import React from "react";
import { FormInstance } from "antd/lib/form";
import BaseForm from "./Form/BaseForm";
import { FormFieldConfig } from "../helpers/shared-interfaces";

interface AllocationBreakdownCalculatorProps {
  reference: React.RefObject<FormInstance>;
  redeemableAmount?: number;
  maturityDate?: string;
  issuedDate?: string;
}

export const AllocationBreakdownCalculator: React.FC<
  AllocationBreakdownCalculatorProps
> = ({ reference, redeemableAmount }) => {
  const fields: FormFieldConfig[] = [
    {
      id: "amount",
      name: "amount",
      inputType: "number",
      rule: "number",
      required: false,
      placeholder: redeemableAmount
        ? `GHS ${redeemableAmount.toFixed(2)}`
        : "Enter amount",
      label: "Redemption Amount (Optional)",
      colConfig: { span: 12 },
      elementStyle: { width: "100%" },
    },
    {
      id: "rediscountDate",
      name: "rediscountDate",
      inputType: "defaultDate",
      rule: "date",
      required: false,
      label: "Rediscount Date (Optional)",
      placeholder: "For early redemption calculation",
      colConfig: { span: 12 },
      elementStyle: { width: "100%" },
    },
  ];

  return (
    <>
      <BaseForm
        layout="vertical"
        reference={reference}
        fields={fields}
        fieldsToHide={[]}
        gutter={[16, 16]}
      />
    </>
  );
};
